import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/study-groups";

export const studyGroupsApi = {
  create: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(BASE, body),

  list: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  getById: (id: string) => apiGet<{ data: Record<string, unknown> }>(`${BASE}/${id}`),

  update: (id: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`${BASE}/${id}`, body),

  delete: (id: string) => apiDelete<{ data: Record<string, unknown> }>(`${BASE}/${id}`),

  join: (id: string) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/${id}/join`),

  leave: (id: string) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/${id}/leave`),

  getMembers: (id: string, params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/${id}/members?${searchParams.toString()}`);
  },

  removeMember: (id: string, memberId: string) => apiDelete<{ data: Record<string, unknown> }>(`${BASE}/${id}/members/${memberId}`),
};